import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class Medication extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> User constructor -', init)
    if (isNil(init)) return undefined
    this._doctor_id = init.doctor_id
    this._doctor_name = init.doctor_name
    this._doctor_phone_number = init.doctor_phone_number
    this._medication_id = init.medication_id
    this._medication_name = init.medication_name
    this._medication_strength = init.medication_strength
  }

  static shape = {
    doctor_id: PropTypes.string,
    doctor_name: PropTypes.string,
    doctor_phone_number: PropTypes.string,
    medication_id: PropTypes.string,
    medication_name: PropTypes.string,
    medication_strength: PropTypes.string
  }

  get doctor_id() {
    return this._doctor_id
  }

  get doctor_name() {
    return this._doctor_name
  }

  get doctor_phone_number() {
    return this._doctor_phone_number
  }

  get medication_id() {
    return this._medication_id
  }

  get medication_name() {
    return this._medication_name
  }

  get medication_strength() {
    return this._medication_strength
  }
}

export default Medication
